// Site-wide constants and brand assets
// NOTE: contact details + positioning are now editable via /admin/content.
// This file remains for build-time assets (logo, fallback media, helpers).
export const SITE = {
  name: "Educators Institute of Management",
  shortName: "Educators",
  // Defaults — overridden at runtime by ContentContext (content.contact.*)
  phone: "+91 62822 66137",
  phoneRaw: "+916282266137",
  whatsappRaw: "916282266137",
  email: "educators.tvm@gmail.com",
  address:
    "2nd Floor Christ University Nodal Office, AIR Road, Vazhuthacadu, Thiruvananthapuram 695014",
  positioning: "We Support You Till You Pass & Get Placed",
  logo: {
    horizontal:
      "https://customer-assets.emergentagent.com/job_placement-academy/artifacts/q0fmi5hr_2.png",
    icon: "https://customer-assets.emergentagent.com/job_placement-academy/artifacts/lgqx71ss_1.png",
    white:
      "https://customer-assets.emergentagent.com/job_placement-academy/artifacts/vvj8qoqx_3.png",
  },
  media: {
    teamWithLogo:
      "https://customer-assets.emergentagent.com/job_placement-academy/artifacts/mi15pvug_WhatsApp%20Image%202026-04-27%20at%203.17.00%20PM.jpeg",
    teamCasual:
      "https://customer-assets.emergentagent.com/job_placement-academy/artifacts/cobootch_WhatsApp%20Image%202026-04-27%20at%203.17.00%20PM%20%281%29.jpeg",
    classroomA:
      "https://customer-assets.emergentagent.com/job_placement-academy/artifacts/movf4zo6_BNZ09919.JPG",
    classroomB:
      "https://customer-assets.emergentagent.com/job_placement-academy/artifacts/yicymhji_BNZ09780.JPG",
    tourVideo:
      "https://customer-assets.emergentagent.com/job_placement-academy/artifacts/yli8a2gk_WhatsApp%20Video%202026-04-27%20at%203.17.41%20PM.mp4",
  },
};

export const buildWhatsAppLink = (text, waNumber) => {
  const num = (waNumber || SITE.whatsappRaw).replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
};

/** Returns merged contact info — runtime content takes precedence over SITE defaults. */
export function getContact(content) {
  const c = content?.contact || {};
  return {
    phone: c.phone || SITE.phone,
    phoneRaw: (c.phone_raw || SITE.phoneRaw).replace(/\s+/g, ""),
    whatsappRaw: (c.whatsapp_raw || SITE.whatsappRaw).replace(/\D/g, ""),
    email: c.email || SITE.email,
    address: c.address || SITE.address,
    positioning: c.positioning || SITE.positioning,
  };
}
